module.exports = __webpack_public_path__ + "img/yd8@2x.bae72ab1.png";